import React from "react";
import { AccessTypes } from "../Constants.ts";

interface request {
    onChange: (v: number) => void,
    initVal: number,
    disabled?: boolean
}

export function AccessTypeDropdown({ onChange, initVal, disabled=false }: request) {

    return (
        <select
            className="form-select"
            value={initVal}
            onChange={(e) => onChange(parseInt(e.target.value))}
            disabled={disabled}
        >
            {AccessTypes.map((x) => (
                <option key={x.id} value={x.id}>{x.value}</option>
            ))}
        </select>
    )
}

export default AccessTypeDropdown;